/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  FileAsAStream,
  WarrantMeterExchangeEligibility,
  WarrantStatus,
  WarrantsAddToMeterExchange,
  WarrantsDeleteAccount,
  WarrantsRemoveFromMeterExchange,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get the warrants journey status for an account.
 */
export const getWarrantStatus = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<WarrantStatus>>,
) => {
  return backofficeRequest<WarrantStatus>(
    {
      url: `/api/v1/accounts/${billingAccountId}/warrants/status`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Get if the account is eligible for being sent for a meter exchange with our provider as part of involuntary PAYG transfers.
 */
export const getMeterExchangeValidity = (
  billingAccountId: number,
  options?: SecondParameter<
    typeof backofficeRequest<WarrantMeterExchangeEligibility>
  >,
) => {
  return backofficeRequest<WarrantMeterExchangeEligibility>(
    {
      url: `/api/v1/accounts/${billingAccountId}/warrants/meter-exchange`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Add an account to the meter exchange journey by creating its ticket in Junifer. Idempotent - if the account already has an active meter exchange ticket, this is a no-op.
 */
export const addToMeterExchangeJourney = (
  billingAccountId: number,
  warrantsAddToMeterExchange: WarrantsAddToMeterExchange,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/api/v1/accounts/${billingAccountId}/warrants/meter-exchange`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: warrantsAddToMeterExchange,
    },
    options,
  )
}
/**
 * @summary Remove an account from the meter exchange journey by moving its ticket into the configured terminal step in Junifer. The account remains in the overall warrants journey.
 */
export const removeFromMeterExchangeJourney = (
  billingAccountId: number,
  warrantsRemoveFromMeterExchange: WarrantsRemoveFromMeterExchange,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/api/v1/accounts/${billingAccountId}/warrants/meter-exchange`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: warrantsRemoveFromMeterExchange,
    },
    options,
  )
}
/**
 * @summary Delete account from warrants journey
 */
export const deleteByAccountNumber = (
  warrantsDeleteAccount: WarrantsDeleteAccount,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/warrants`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: warrantsDeleteAccount,
    },
    options,
  )
}
/**
 * @summary Take a CSV file of account numbers and add them to the whitelist for warrants
 */
export const addFileToWhitelist = (
  fileAsAStream?: FileAsAStream,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  const formData = new FormData()
  if (fileAsAStream?.file !== undefined) {
    formData.append(`file`, fileAsAStream.file)
  }

  return backofficeRequest<void>(
    {
      url: `/warrants/whitelist`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  )
}
export type GetWarrantStatusResult = NonNullable<
  Awaited<ReturnType<typeof getWarrantStatus>>
>
export type GetMeterExchangeValidityResult = NonNullable<
  Awaited<ReturnType<typeof getMeterExchangeValidity>>
>
export type AddToMeterExchangeJourneyResult = NonNullable<
  Awaited<ReturnType<typeof addToMeterExchangeJourney>>
>
export type RemoveFromMeterExchangeJourneyResult = NonNullable<
  Awaited<ReturnType<typeof removeFromMeterExchangeJourney>>
>
export type DeleteByAccountNumberResult = NonNullable<
  Awaited<ReturnType<typeof deleteByAccountNumber>>
>
export type AddFileToWhitelistResult = NonNullable<
  Awaited<ReturnType<typeof addFileToWhitelist>>
>
